import {
  AWFRoute,
  AWFRouteItem,
  AWFRouteOverrides,
} from '@ansys-internal/awf-angular/core';
import {
  WorkspaceGridLayout,
  WorkspaceLayoutSlots,
} from '@ansys-internal/awf-angular/workspace';
import {
  DashboardMainTab,
  FileIconColumn,
  FilesMoreMenu,
  FilesTable,
  LibraryDescriptionColumn,
  LibraryTable,
  ProjectCreateFileMenu,
  ProjectMoreMenu,
  StudyTable,
} from '@ansys-internal/awf-angular/dashboard';
import { ConceptTab } from '../../tabs/concept-tab/concept-tab';
import { ImportFromFileMenu } from '../../menus/project-create-file-menu/import-from-file.menu';
import { Type } from '@angular/core';
import { ProjectEditMenu } from '../../tables/projects/menu/project-edit-menu.service';
import { FilesTableCreateProjectFromDesign } from '../../tables/files/menu/files-table-create-project-from-design.menu-item';
import { UserProfileMenu } from '@ansys-internal/awf-angular/shared';
import { AboutMenu } from '../../menus/user-profile-menu/about-menu';
import { FeatureFlagMenu } from '../../menus/user-profile-menu/feature-flag.menu';
import { HelpMenu } from '../../menus/user-profile-menu/help-menu';
import { FilesLogoColumn } from '../../tables/files/files-logo-column';
import { StudyProjectColumn } from '../../tables/study/study-table-project-column';
import { LibraryIconColumn } from '../../tables/library/library-icon-column';
import { LibraryTypeColumn } from '../../tables/library/library-type-column';
import { ConceptTitleComponent } from '../../../components/layout/slots/concept-title/concept-title.component';
import { ConceptNavigationToolsComponent } from '../../../components/layout/slots/concept-navigation-tools.component/concept-navigation-tools.component';
import { FilesTableExportDesignMenuItem } from '../../tables/files/menu/files-table-export-design.menu-item';

@AWFRouteItem({
  path: 'ws',
  rootPage: true,
  layout: {
    default: {
      layout: WorkspaceGridLayout,
      components: {
        [WorkspaceLayoutSlots.SECTION_HEADER]: ConceptTitleComponent,
        [WorkspaceLayoutSlots.RIGHT_NAV]: ConceptNavigationToolsComponent,
      },
    },
  },
  children: [DashboardMainTab, ConceptTab],
})
@AWFRouteOverrides([
  {
    menu: ProjectCreateFileMenu as Type<unknown>,
    add: [ImportFromFileMenu],
  },
  {
    menu: ProjectMoreMenu as Type<unknown>,
    add: [ProjectEditMenu],
  },
  {
    menu: FilesMoreMenu as Type<unknown>,
    add: [FilesTableCreateProjectFromDesign, FilesTableExportDesignMenuItem],
  },
  {
    menu: UserProfileMenu as Type<unknown>,
    add: [AboutMenu, FeatureFlagMenu, HelpMenu],
  },
  {
    table: FilesTable,
    add: [FilesLogoColumn],
    remove: [FileIconColumn],
  },
  {
    table: StudyTable,
    add: [StudyProjectColumn],
  },
  {
    table: LibraryTable,
    add: [LibraryIconColumn, LibraryTypeColumn],
  },
])
export class WorkspacePage implements AWFRoute {
  // type = PagesEnum.WORKSPACE;
  title = 'Workspace';
  description = 'Workspace';
}
